import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class UtilityService extends Service {
  async getBoard(params?: any) {
    const httpResponse = await this.httpClient.get('/diretoria', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getOwner(params?: any) {
    const httpResponse = await this.httpClient.get('/proprietario', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getResultCenter(params?: any) {
    const httpResponse = await this.httpClient.get(`/centroresultado`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }
}

export const utilityPreparationService = new UtilityService()
